import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

// STATE
const state = () => ({
	isSponsoredRecommendationCohort: null,
});

type State = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<State, any> = {
	isSponsoredRecommendationCohort(state): boolean | null {
		return state.isSponsoredRecommendationCohort;
	},
};

// ACTIONS
const actions: ActionTree<State, any> = {
	setSponsoredRecommendationCohort({ commit }) {
		let result = true;

		const randomSeed = Math.floor(Math.random() * 100);
		// Number represents percentage chance of user getting SR
		if (randomSeed > 95) result = false;

		commit('SET_SPONSORED_RECOMMENDATION_COHORT', result);
	},
};

// MUTATIONS
const mutations: MutationTree<State> = {
	SET_SPONSORED_RECOMMENDATION_COHORT(state, result) {
		state.isSponsoredRecommendationCohort = result;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<State, any>;
